import { KnownBusinessEntityContact } from "@/models/known-business-entity-contact.model.ts"
import { useKnownBusinessEntitiesContactsStore } from "@/store/known-business-entities-contacts.store.ts"
import { storeToRefs } from "pinia"
import { createRule, type Maybe } from "@regle/core"

function KBECEmailIsUnique(
  email: Maybe<string>,
  model: KnownBusinessEntityContact | undefined
): boolean {
  if (!model) return true
  const knownBusinessEntityContactStore = useKnownBusinessEntitiesContactsStore()
  const { activeKnownBusinessEntitiesContacts } = storeToRefs(knownBusinessEntityContactStore)

  return !activeKnownBusinessEntitiesContacts.value.some((kbec) => {
    return !!kbec.email && kbec.email.toLowerCase() === email?.toLowerCase() && kbec.id !== model.id
  })
}

export const KBECEmailIsUniqueValidator = createRule({
  validator: KBECEmailIsUnique,
  message: "Er bestaat al een persoon bij dit bedrijf met dit e-mailadres"
})

function personPhoneNumberIsUnique(
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  phoneNumber: Maybe<string>,
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  model: KnownBusinessEntityContact | undefined
): boolean {
  return true // Disabled until further notice
  // const knownBusinessEntityContactStore = useKnownBusinessEntitiesContactsStore()
  // const { activeKnownBusinessEntitiesContacts } = storeToRefs(knownBusinessEntityContactStore)
  //
  // return !activeKnownBusinessEntitiesContacts.value.some((kbec) => {
  //   return kbec.phoneNumber && kbec.phoneNumber === phoneNumber && kbec.person.id !== model.person.id
  // })
}

export const personPhoneNumberIsUniqueValidator = createRule({
  validator: personPhoneNumberIsUnique,
  message: "Er bestaat al een persoon met dit telefoonnummer"
})
